define([
    "jquery",
    "components/modal",
    "components/dropdown",
    "components/fake-progress",
    "core/utilities",
    "core/urls",
    "core/iterate",
    'core/browser-storage',
    "components/selectize",
], function (
    $,
    modal,
    DD,
    FakeProgress,
    utilities,
    urls,
    iterate
) {
    var nodes = {
        modal: {
            modal: document.querySelector(".modal_js"),
            close: document.querySelector(".modal-close_js"),
            content: document.querySelector(".modal-content_js"),
            title: document.querySelector(".modal-title_js"),
            bg: document.querySelector(".modal-bg_js"),
            blur: [
                document.querySelector(".create-survey-s3"),
                document.querySelector(".sidebar-nav"),
                document.querySelector(".navigation-top")
            ],
        },
        deleteCategoryModal: document.querySelector('.modal-template-delete-category'),
        previewModal: document.querySelector(".modal-template-preview"),
        previewButton: document.querySelector(".preview-survey"),
        surveyQuestions: document.querySelectorAll(".survey-questions .question"),
        addQuestion: document.querySelector(".add-question"),
        removeQuestion: document.querySelectorAll(".question .remove"),
        mainForm: document.querySelector("form.main-form"),
        form: {
            thankYou: document.querySelector("#id_thank_you_message"),
            thankYouError: document.querySelector(".input-error.thank-you"),
            questionsWrap: document.querySelector(".survey-questions .questions-wrap"),
            questions: document.querySelectorAll(".survey-questions .question"),
            questionWraps: document.querySelectorAll(".survey-questions .question-wrap"),
            questionsError: document.querySelector(".input-error.questions"),
            resetButtons: document.querySelectorAll(".reset-input"),
            requestCommentsToggle: document.querySelector("#id_accept_comments"),
            permissionsWrap: document.querySelector(".permissions-wrap"),
            permissionsToggle: document.querySelector(".permissions-wrap input#id_ask_for_marketing_permissions"),
            googleToggle: document.querySelector(".permissions-wrap #enable_google_reviews"),
            googleOptionsWrapper: document.querySelector(".permissions-wrap .google-review-options"),
            googleOptions: document.querySelectorAll(".permissions-wrap .google-review-options .radio-wrapper input"),
            googleInput: document.querySelector(".permissions-wrap #googleUrl"),
            googleError: document.querySelector(".permissions-wrap .google-input .error-message"),
        },
        submitButton: document.querySelector(".projects-survey-submit_js"),
        loaderElement: document.querySelector(".marketing-loader"),
        loaderHint: document.querySelector(".marketing-loader .loader-bar-wrap_hint"),
    };

    let createdModal = modal.create(nodes.modal, function (el) {});

    let questionDropdowns = {};

    let showSurveyPreview = async (surveyId) => {
        await fetch(urls['projects:survey_preview'](surveyId), {
            method: nodes.mainForm.method,
            body: new FormData(nodes.mainForm),
        })
        .then(async (response) => {
            let iframe = nodes.previewModal.querySelector('iframe');
            iframe.srcdoc = await response.text();
        })
        .then(() => {
            createdModal.open({
                class: "survey-preview-modal",
                content: nodes.previewModal.innerHTML,
                title: "Survey Preview"
            }, function (el) {
                // modal callback
            });
        })
    }

    let modalTemplate = document.querySelector(".modal-template-leave_js");
    let hrefs = document.querySelectorAll("a[href]"); 
    let surveyId = document.querySelector("[data-survey-id]").dataset.surveyId;

    let hrefsToIgnore = [
        urls['projects:start_projects_survey'](surveyId),
        urls['projects:start_projects_survey_s2'](surveyId),
        urls['projects:start_projects_survey_s3'](surveyId),
        urls['projects:start_projects_survey_s4'](surveyId),
    ];

    let loadingScreen = new FakeProgress(
        document.querySelector(".marketing-loader .loader-bar-wrap-bar")
    );
    
    function exitWarningGeneric() {
        iterate(hrefs, function (node) {
            node.addEventListener("click", (event) => {
                utilities.confirmPageExit(
                    event,
                    createdModal,
                    modalTemplate,
                    null,
                    hrefsToIgnore
                );
            });
        });
    }
    
    let validationConfigs = [
        {
            input: nodes.form.thankYou,
            errorNode: nodes.form.thankYouError,
            validations: ["hasValue", "notTooLong"],
        },
        {
            input: nodes.form.questionWraps,
            errorNode: nodes.form.questionsError,
            validations: ["noRepeatQuestions"],
        },
        {
            input: nodes.form.googleInput,
            errorNode: nodes.form.googleError,
            validations: ["hasValue", "isValidURL"],
        }
    ];

    let addDeleteCategoryButtons = (dropdown, newCategoryName) => {
        let buttonHTML = `  <div class="delete-category tooltip-wrap glyphicons glyphicons-remove-sign">
                                <div class="sb-tooltip">Delete Category</div>
                            </div>`
        let mockOptions = dropdown.querySelectorAll(".mock-options .mock-option");

        mockOptions.forEach(option => {
            let existingDeleteButton = option.querySelector(".delete-category");
            if((option.dataset.custom === "true" || option.innerText === newCategoryName) && !existingDeleteButton) {
                option.innerHTML += buttonHTML;
            }
        })
    }

    let submitCustomCategory = (dropdown) => {
        let mockOptions = dropdown.querySelector(".mock-options");
        let currentInput = mockOptions.querySelector("input");
        let inputContainer = mockOptions.querySelector(".custom-submit-wrap");
        let errorNode = inputContainer.querySelector(".error");
        let regex = /^[ A-Za-z0-9_@./#'&+-]*$/;

        if(!currentInput.value || currentInput.value === "") {
            return;
        }

        if(!currentInput.value.trim().length) {
            errorNode.innerText = "Please enter a category name"
            inputContainer.classList.add("show-error");
            return;
        }
                    
        if(!regex.test(currentInput.value)) {
            errorNode.innerText = "Name contains invalid characters"
            inputContainer.classList.add("show-error");
            return;
        }
        
        let formData = new FormData();
        formData.append('name', currentInput.value.trim());

        fetch(urls['projects:category_create'](),
            {
                body: formData,
                method: "POST",
            }
        )
        .then((response) => response.json())
        .then((data) => {
            inputContainer.classList.remove("show-error");

            if(data.error) {
                errorNode.innerText = data.error;
                inputContainer.classList.add("show-error");
            } else {
                // add new item to all dropdown
                for (const i in questionDropdowns) {
                    // only select new custom category for the dropdown that we added it in
                    let dropdownElement = questionDropdowns[i].info().targetElement;
                    let maintainSelection = dropdownElement !== dropdown;
                    questionDropdowns[i].addOption(data.id, currentInput.value.trim(), true, maintainSelection);
                    addDeleteCategoryButtons(dropdownElement, currentInput.value.trim());
                }

                // scroll to new option 
                let newOption = mockOptions.querySelector("div.active")
                let newOptionPosition = newOption.offsetTop;

                mockOptions.scrollTop = newOptionPosition;
                document.querySelector(".canvas").click();
                currentInput.value = '';
                mockOptions.querySelector(".submit-category").classList.add("disabled");
            }
        });
    }

    let addCustomCategory = (dropdown) => {
        let mockOptions = dropdown.querySelector(".mock-options");
        let customCateogryHTML = `
            <div class="custom-submit-wrap">
                <div class="flex-wrapper">
                    <input maxlength="30" class="custom-category" placeholder="Add custom category" />
                    <div class="submit-category button-primary disabled"></div>
                </div>
                <div class="error"></div>
            </div>
        `;

        mockOptions.insertAdjacentHTML("beforeend", customCateogryHTML);

        let newInput = mockOptions.querySelector("input");
        let newSubmit = mockOptions.querySelector(".submit-category");
        let inputContainer = mockOptions.querySelector('.custom-submit-wrap');

        newInput.addEventListener("keyup", (event) => {
            if (event.keyCode === 13) {
                event.preventDefault();
                submitCustomCategory(dropdown);
            } else {
                // hide any errors
                inputContainer.classList.remove("show-error");
            }
            event.target.value.length ? newSubmit.classList.remove("disabled") : newSubmit.classList.add("disabled");
        })

        newSubmit.addEventListener("click", () => {
            submitCustomCategory(dropdown);
        })
    }

    let removeDeletedCategory = (id, name) => {
        for(const property in questionDropdowns) {
            questionDropdowns[property].removeOption(id, name);
        }
    }

    let createEventListeners = () => {
        // add question
        nodes.addQuestion.addEventListener("click", (event) => {
            event.preventDefault();
            
            let hiddensSurveyQuestions = document.querySelectorAll(".survey-questions .question-wrap.hide")
            
            if(hiddensSurveyQuestions.length) {
                // reset dropdown
                let questionNumber = hiddensSurveyQuestions[0].querySelector(".survey-question-selector").dataset.counter;
                questionDropdowns[questionNumber].reset();

                // show the first hidden question
                hiddensSurveyQuestions[0].classList.remove("hide");
                // enable newly added select input
                hiddensSurveyQuestions[0].querySelector("select").disabled = false;
                
                if(hiddensSurveyQuestions.length === (nodes.surveyQuestions.length - 1)) {
                    // show all 'remove' buttons after revealing the first hidden question
                    nodes.form.questionWraps.forEach(wrap => {
                        wrap.classList.remove("hide-remove-button");
                    });
                }
            }

            if(hiddensSurveyQuestions.length === 1) {
                // final question, so hide 'add question' button
                nodes.addQuestion.classList.add("hide");
            }
        });

        nodes.removeQuestion.forEach((node) => {
            node.addEventListener("click", (event) => {
                // hide the question
                let questionWrapper = event.currentTarget.parentElement.parentElement;
                questionWrapper.classList.add('hide');
                questionWrapper.querySelector("select").disabled = true;
                
                // show 'add question' button
                nodes.addQuestion.classList.remove("hide");

                // if only one question remains - hide the associated 'remove' button
                let visibleQuestions = document.querySelectorAll(".survey-questions .question-wrap:not(.hide)");
                if(visibleQuestions.length === 1) {
                    visibleQuestions[0].classList.add("hide-remove-button");
                }

                // move question to end of siblings
                nodes.form.questionsWrap.appendChild(questionWrapper);

            })
        })

        nodes.form.requestCommentsToggle.addEventListener("click", (event) => {
            if(event.target.checked) {
                nodes.form.permissionsWrap.classList.add("active");
                nodes.form.permissionsToggle.checked = true;
                nodes.form.googleToggle.checked = true;
                nodes.form.googleInput.disabled = false;
            } else {
                nodes.form.permissionsWrap.classList.remove("active");
                nodes.form.permissionsToggle.checked = false;
                nodes.form.googleToggle.checked = false;
                nodes.form.googleInput.disabled = true;
            }
        })

        nodes.form.googleToggle.addEventListener("click", event => {
            if(event.target.checked) {
                nodes.form.googleInput.disabled = false;
                nodes.form.googleOptionsWrapper.classList.remove("hide");
                nodes.form.googleOptions.forEach(option => {
                    option.disabled = false;
                })
            } else {
                nodes.form.googleInput.disabled = true;
                nodes.form.googleOptionsWrapper.classList.add("hide");
                nodes.form.googleOptions.forEach(option => {
                    option.disabled = true;
                })
            }
        })

        nodes.submitButton.addEventListener("click", (event) => {
            event.preventDefault();
            let formIsValid = utilities.validateForm(validationConfigs);

            if(formIsValid) {
                nodes.mainForm.submit();
            }
        })

        nodes.form.resetButtons.forEach(reset => {
            reset.addEventListener("click", () => {
                let input = reset.parentElement.querySelector('textarea');
                if(!input) {
                    input = reset.parentElement.querySelector('input');
                }
                
                input.value = input.getAttribute("data-default");

                reset.classList.add("roll");

                setTimeout(() => {
                    reset.classList.remove("roll");
                }, 300);
            })
        })

        nodes.previewButton.addEventListener("click", (event) => {
            event.preventDefault();
            
            let formIsValid = utilities.validateForm(validationConfigs);

            if(formIsValid) {
                let surveyId = nodes.previewButton.getAttribute("data-survey-id");
                showSurveyPreview(surveyId);
            }
        })

        nodes.form.questionsWrap.addEventListener("click", (event) => {
            let targetClassList = event.target.classList;
            if(targetClassList.contains("delete-category")) {
                let backgroundElement = document.querySelector(".main-content");
                let deleteButton = event.target;
                let categoryName = deleteButton.parentElement.firstChild.nodeValue.trim();
                let categoryId = deleteButton.parentElement.dataset.value;

                // click background to close dropdown
                backgroundElement.click();

                let content = `
                    <div class="body">
                        Are you sure you want to delete the category <strong>'${categoryName}'</strong>?
                    </div>
                    <div class="body">
                        Any existing surveys containing this category will <em>not</em> be affected.
                    </div>
                    <div class="buttons">
                        <button class="button-secondary close-sb-modal_js">Cancel</button>
                        <button data-id="${categoryId}" class="button-primary delete">Delete</button>
                    </div>
                `;

                createdModal.open({
                    class: "delete-category-modal",
                    content: content,
                    title: `Delete Category`
                }, function (el) {
                    let deleteButton = el.querySelector("button.delete");
                    deleteButton.addEventListener("click", () => {
                        fetch(urls['projects:category_delete'](deleteButton.dataset.id), {
                            method: "DELETE",
                        })
                        .then(() => {
                            removeDeletedCategory(deleteButton.dataset.id, categoryName);
                            createdModal.close();
                        })                        
                    })
                });           
            }

            if(targetClassList.contains("mock-option") || targetClassList.contains("remove")) {
                nodes.form.questionsError.classList.add("hide");
                nodes.form.questionsWrap.classList.remove("error");
            }
        })

    }

    return {
        init: function () {

            // initialize question dropdowns
            nodes.surveyQuestions.forEach((question, i) => {
                questionDropdowns[i] = DD(question.querySelector(".survey-question-selector"), null, (element) => {
                    addCustomCategory(element, i);
                    addDeleteCategoryButtons(element)
                });
            })

            utilities.addCharacterCount("#id_thank_you_message", 140)
            
            if(!nodes.form.questionWraps[1].classList.contains("hide")) {
                nodes.form.questionWraps.forEach(wrap => {
                    wrap.classList.remove("hide-remove-button");
                })
            }

            let hiddensSurveyQuestions = document.querySelectorAll(".survey-questions .question-wrap.hide")
            if(hiddensSurveyQuestions.length === 0) {
                // final question, so hide 'add question' button
                nodes.addQuestion.classList.add("hide");
            }

            if(!nodes.form.requestCommentsToggle.checked) {
                nodes.form.permissionsWrap.classList.remove("active");
                nodes.form.permissionsToggle.checked = false;
                nodes.form.googleInput.disabled = true;
            }

            if(nodes.form.googleInput.value === "" & nodes.form.googleInput.dataset.savedUrl !== "") {
                nodes.form.googleInput.value = nodes.form.googleInput.dataset.savedUrl;
            }

            if(nodes.form.googleToggle.checked) {
                nodes.form.googleOptionsWrapper.classList.remove("hide");
                nodes.form.googleInput.disabled = false;

                let savedRadioValue = nodes.form.googleOptionsWrapper.getAttribute("saved-radio-value");
                if(savedRadioValue) {
                    let radioButtons = nodes.form.googleOptionsWrapper.querySelectorAll('input[name="google_review_score_minimum"]');
                    radioButtons.forEach((button) => {
                        if(button.value == savedRadioValue) {
                            button.checked = true;
                        }
                    })
                }
            }

            createEventListeners();
            exitWarningGeneric();
        },
    };
});